import React, { ReactNode } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import ErrorPage from "./ErrorPage";

function ErrorFallback({
  error,
  componentStack,
  resetErrorBoundary,
}: FallbackProps) {
  return <ErrorPage />;
}

interface ErrorHandlerProps {
  children: ReactNode;
}

export default function ErrorHandler({ children }: ErrorHandlerProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {}}>
      {children}
    </ErrorBoundary>
  );
}
